import React, { Fragment } from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import Select from 'react-select';
import { DeleteIcon } from '../../../svg/UtilsIcons';
import CreateDatastream from './CreateDatastream';

const FanWidgetSettings = ({
	edit,
	setEdit,
	t,
	devices,
	validDatastreams,
	deviceSelectOptions,
	setAddDatastream,
	setAlertMessage,
	setAlertType,
	setShowAlert,
}) => (
<Fragment>
												<button
													className="details-add-btn"
													style={{ width: '180px', marginBottom: '10px' }}
													onClick={() => {
														const currentStreams = edit.props.datastreams || [];
														if (currentStreams.length >= 10) {
															setAlertMessage("Maximum of 10 datastreams reached.");
															setAlertType('warning');
															setShowAlert(true);
															return;
														}
														const newStream = {
															deviceId: (devices || [])?.[0]?.id || 0,
															pin: '',
															speed: 1,
															label: `Datastream ${currentStreams.length + 1}`,
															isActive: false
														};
														setEdit(prev => ({
															...prev,
															props: {
																...prev.props,
																datastreams: [...currentStreams, newStream]
															}
														}));
													}}
												>
													<span>+</span><span>Add Datastream</span>
												</button>

												{(edit.props.datastreams || []).map((stream, index) => {
													const handleToggle = () => {
														const updatedStreams = (edit.props.datastreams || []).map((s, i) => ({
															...s,
															isActive: i === index ? !s.isActive : false,
														}));
														setEdit(prev => ({
															...prev,
															props: { ...prev.props, datastreams: updatedStreams }
														}));
													};

													return (
														<div className="details-curves-item" key={index} style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '10px', borderBottom: '1px solid var(--header-background)' }}>
															<div className='details-hierarchy-tree' style={{ width: '100%', flexDirection: 'row', alignItems: 'center' }}>
																{stream.isActive
																	? <ToggleOn style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }} onClick={handleToggle} />
																	: <ToggleOff style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }} onClick={handleToggle} />
																}
																<b style={{ color: 'var(--header-color)', flexGrow: 1 }}>{stream.label || `Datastream ${index + 1}`}</b>
																<button
																	className="details-delete-btn"
																	style={{ position: 'static' }}
																	onClick={() => {
																		setEdit(prev => ({
																			...prev,
																			props: {
																				...prev.props,
																				datastreams: (prev.props.datastreams || []).filter((_, i) => i !== index),
																			},
																		}))
																	}}
																>
																	<DeleteIcon  />
																</button>
															</div>

															{
																!devices && (
																	<>
																		{(validDatastreams?.length > 0) && (
																			<div className="form-item">
																				<label className="form-lbl" style={{ color: 'var(--header-color)' }}>{t.pinLabel}</label>
																				<Select
																					classNamePrefix="react-select"
																					options={validDatastreams.map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin }))}
																					value={validDatastreams.map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin })).find(ds => ds.value === stream.pin)}
																					onChange={selectedOption => {
																						const updatedStreams = [...(edit.props.datastreams || [])];
																						const dsInfo = validDatastreams.find(d => d.pin === (selectedOption ? selectedOption.value : ''));
																						updatedStreams[index].pin = selectedOption ? selectedOption.value : '';
																						if (dsInfo) updatedStreams[index].label = dsInfo.name;
																						setEdit(prev => ({ ...prev, props: { ...prev.props, datastreams: updatedStreams } }));
																					}}
																					isClearable={true}
																				/>
																			</div>
																		)}
																		<CreateDatastream onSelect={(cat) => setAddDatastream({ edit: true, pinCategory: cat })} />
																	</>
																)
															}

															{((devices?.length > 0) && Array.isArray(devices)) && (
																<Fragment>
																	<div className="form-item">
																		<label className="form-lbl" style={{ color: 'var(--header-color)' }}>{t.deviceLabel}</label>
																		<Select
																			classNamePrefix="react-select"
																			options={deviceSelectOptions}
																			value={deviceSelectOptions.find(d => d.value === stream.deviceId)}
																			onChange={selectedOption => {
																				const updatedStreams = [...(edit.props.datastreams || [])];
																				updatedStreams[index].deviceId = selectedOption ? selectedOption.value : 0;
																				updatedStreams[index].pin = '';
																				setEdit(prev => ({ ...prev, props: { ...prev.props, datastreams: updatedStreams } }));
																			}}
																			isClearable={true}
																		/>
																	</div>

																	{stream.deviceId && (
																		<div className="form-item">
																			<label className="form-lbl" style={{ color: 'var(--header-color)' }}>{t.pinLabel}</label>
																			<Select
																				classNamePrefix="react-select"
																				options={(((devices || [])).find(d => d.id === stream.deviceId)?.template?.datastreams || []).filter(ds => ds).map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin }))}
																				value={(((devices || [])).find(d => d.id === stream.deviceId)?.template?.datastreams || []).filter(ds => ds).map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin })).find(ds => ds.value === stream.pin)}
																				onChange={selectedOption => {
																					const updatedStreams = [...(edit.props.datastreams || [])];
																					const dsInfo = (((devices || [])).find(d => d.id === stream.deviceId)?.template?.datastreams || []).filter(d => d).find(d => d.pin === (selectedOption ? selectedOption.value : ''));
																					updatedStreams[index].pin = selectedOption ? selectedOption.value : '';
																					if (dsInfo) updatedStreams[index].label = dsInfo.name;
																					setEdit(prev => ({ ...prev, props: { ...prev.props, datastreams: updatedStreams } }));
																				}}
																				isClearable={true}
																			/>
																		</div>
																	)}
																</Fragment>
															)}

															<div className="form-item">
																<label className="form-lbl" style={{ color: 'var(--header-color)' }}>Speed (1-{edit.props.maxSpeed || 10})</label>
																<Select
																	classNamePrefix="react-select"
																	options={Array.from({ length: edit.props.maxSpeed || 10 }, (_, i) => ({ label: `Speed ${i + 1}`, value: i + 1 }))}
																	value={Array.from({ length: edit.props.maxSpeed || 10 }, (_, i) => ({ label: `Speed ${i + 1}`, value: i + 1 })).find(o => o.value === stream.speed)}
																	onChange={selectedOption => {
																		const updatedStreams = [...(edit.props.datastreams || [])];
																		updatedStreams[index].speed = selectedOption ? selectedOption.value : 0;
																		setEdit(prev => ({ ...prev, props: { ...prev.props, datastreams: updatedStreams } }));
																	}}
																	isClearable={true}
																/>
															</div>
														</div>
													)
												})}
											</Fragment>
);

export default FanWidgetSettings;
